module.exports = __webpack_public_path__ + "static/img/j-logo.956e181.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vpn/j-logo.png
// module id = IGnx
// module chunks = 1